import { Breakpoint, useMediaQuery, useTheme } from '@rhg/libs/material';

export function useCurrentBreakpointName(): Breakpoint {
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const isMd = useMediaQuery(theme.breakpoints.between('md', 'lg'));
    const isLg = useMediaQuery(theme.breakpoints.between('lg', 'xl'));
    const isXl = useMediaQuery(theme.breakpoints.up('xl'));

    if (isXl) {
        return 'xl';
    } else if (isLg) {
        return 'lg';
    } else if (isMd) {
        return 'md';
    } else if (isSm) {
        return 'sm';
    } else {
        return 'xs';
    }
}
